export const getNewestByCreatedDate = (array: any[]): any => {
  const sorted = array.sort(function (a, b) {
    return (new Date(b.createdAt) as any) - <any>new Date(a.createdAt);
  });

  return sorted[0];
};
